export function propertyRequirementsVersion(obj) {
  if (!obj) return
  // Has to be sorted highest to lowest!
  if (obj?.forceShowOnAppStart) return '>=24.21.x'
  if (obj?.walletBanner) return '>=24.21.0'
  if (obj?.type) return '>=23.10.19'
  if (obj?.showContactUs) return '>=20.7.2'
}
